/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Leftcapacity1Inputs */

const en__field_leftcapacity1 = /** @type {(inputs: _Field_Leftcapacity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`remaining free seets`)
};

const de__field_leftcapacity1 = /** @type {(inputs: _Field_Leftcapacity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verbleibende freie Plätze`)
};

/**
* | output |
* | --- |
* | "remaining free seets" |
*
* @param {_Field_Leftcapacity1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_leftcapacity1 = /** @type {((inputs?: _Field_Leftcapacity1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Leftcapacity1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_leftcapacity1(inputs)
	return de__field_leftcapacity1(inputs)
});
export { _field_leftcapacity1 as "_field_leftCapacity" }